import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../../stores/authStore";

export default function AdminRoute({ children }) {
    const user = useAuthStore((state) => state.user);

    if (!user) {
        return <Navigate to='/login' replace />;
    }

    if (!user.is_admin) {
        return<Navigate to='/' replace />
    }

    return children;
}